module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_triangle-5be5efe83478083d1a26d9384c4d9891.svg";